import { render, staticRenderFns } from "./ProductCustomization.vue?vue&type=template&id=c3400be8&scoped=true&"
import script from "./ProductCustomization.vue?vue&type=script&lang=js&"
export * from "./ProductCustomization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3400be8",
  null
  
)

export default component.exports